import { render, staticRenderFns } from "./details-matrix.page.vue?vue&type=template&id=17042b34&scoped=true"
import script from "./details-matrix.page.vue?vue&type=script&lang=js"
export * from "./details-matrix.page.vue?vue&type=script&lang=js"
import style0 from "./details-matrix.page.vue?vue&type=style&index=0&id=17042b34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17042b34",
  null
  
)

export default component.exports